/** @ngInject */
export default function config($stateProvider) {
	$stateProvider
		.state('app.tasks', {
			abstract: true,
			url: '/tasks',
		})
		.state('app.tasks.index', {
			url: '',
			component: 'tasksIndexState',
		})
		.state('app.tasks.index.new', {
			url: '/new',
			/** @ngInject */
			onEnter: function ($stateParams, $state, $document, $mdDialog) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/tasks/tasks-new.html',
							controller: 'TasksNewStateController',
							bindToController: true,
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
						})
						.finally(function () {
							$state.go('^')
						})
				})
			},
			resolve: {
				/** @ngInject */
				isAuthorized: function (authService) {
					return authService.checkAccessPromise(authService.roles.admin)
				},
			},
		})
		.state('app.tasks.index.show', {
			url: '/:id',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$document,
				$mdDialog,
				$log,
				task,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/tasks/tasks-show.html',
							controller: 'TasksShowStateController',
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
							bindToController: true,
							locals: {
								task: task,
							},
						})
						.then(
							function () {
								$log.info('Closed normally.')
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			/** @ngInject */
			onExit: function ($mdDialog) {
				$mdDialog.hide()
			},
			resolve: {
				/** @ngInject */
				task: function ($stateParams, Task) {
					return Task.find($stateParams.id)
				},
			},
		})
		.state('app.tasks.index.edit', {
			url: '/:id/edit',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$document,
				$mdDialog,
				$log,
				task,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/tasks/tasks-edit.html',
							controller: 'TasksEditStateController',
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
							bindToController: true,
							locals: {
								task: task,
							},
						})
						.then(
							function () {
								$log.info('Closed normally.')
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			/** @ngInject */
			onExit: function ($mdDialog) {
				$mdDialog.hide()
			},
			resolve: {
				/** @ngInject */
				task: function ($stateParams, Task) {
					return Task.find($stateParams.id, { bypassCache: true })
				},
				/** @ngInject */
				isAuthorized: function (authService) {
					return authService.checkAccessPromise(authService.roles.admin)
				},
			},
		})
		.state('app.tasks.index.delete', {
			url: '/:id/delete',
			/** @ngInject */
			onEnter: function ($stateParams, $state, $mdDialog, $log, Task, task) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show(
							$mdDialog.confirm({
								title: 'Are you sure?',
								textContent:
									'Are you sure you want to delete ' + task.name + '?',
								ok: 'Delete',
								cancel: 'Cancel',
								theme: 'md-navbarTheme-theme',
							}),
						)
						.then(
							function () {
								task.DSDestroy().finally(function () {
									$state.go('^')
								})
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			resolve: {
				/** @ngInject */
				task: function ($stateParams, Task) {
					return Task.find($stateParams.id)
				},
				/** @ngInject */
				isAuthorized: function (authService) {
					return authService.checkAccessPromise(authService.roles.admin)
				},
			},
		})
}
